import { render, staticRenderFns } from "./additionalInformationItem.vue?vue&type=template&id=275b6dfc&scoped=true&"
import script from "./additionalInformationItem.vue?vue&type=script&lang=js&"
export * from "./additionalInformationItem.vue?vue&type=script&lang=js&"
import style0 from "./additionalInformationItem.vue?vue&type=style&index=0&id=275b6dfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275b6dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('275b6dfc', component.options)
    } else {
      api.reload('275b6dfc', component.options)
    }
    module.hot.accept("./additionalInformationItem.vue?vue&type=template&id=275b6dfc&scoped=true&", function () {
      api.rerender('275b6dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/additionalInformationItem.vue"
export default component.exports